<template lang='pug' src='./custom-contact-columns.pug'></template>

<script>
import FormContact from 'components/form/form-contact/form-contact'

export default {
  props: ['props'],
  data () {
    return {
      titleActive: false
    }
  },
  components: {
    FormContact
  }
}
</script>



// WEBPACK FOOTER //
// custom-contact-columns.vue?71d947a8